import type { IComponent } from "@Components/Component";
import { defaultAttributes } from "@Components/Component";
import { Panel, TitleAlignment } from "@Components/Panel";
import type { IRepeater } from "@Components/Repeater";
import { ItemTemplate, NoResultsTemplate, Repeater } from "@Components/Repeater";

import type { IContentContainer } from "../common/ContentContainer";
import ContentContainer from "../common/ContentContainer";
import LogoTile, { type ILogoTile } from "../common/LogoTile";

import * as cssPortal from "../shared/Portal.module.css";
import * as css from "./ShoppingMallsList.module.css";

export interface IShoppingMallsList extends IComponent {
    title: string;
    repeater: IRepeater;
    contentContainers?: IContentContainer;
}

export function ShoppingMallsList(props: IShoppingMallsList) {
    return (
        <div {...defaultAttributes(props, css.shoppingMallsListComponent, cssPortal.standardContainer)}>
            <Panel title={props.title} titleAlignment={TitleAlignment.Left} titleElement="h1">
                <Repeater {...props.repeater}>
                    <ItemTemplate>
                        <LogoTile {...({} as ILogoTile)} />
                    </ItemTemplate>
                    <NoResultsTemplate />
                </Repeater>
            </Panel>
            <ContentContainer {...props.contentContainers} />
        </div>
    );
}
